import { FeatureAccess } from "@thepiquelab/web-types";
import React, { createContext } from "react";
import { usePostFeatureDataSubscription } from "./hooks/usePostFeatureDataSubscription";

export const CommonCacheContext = createContext<{
  enabledFeatureData?: FeatureAccess[] | null;
  enabledFeatureDataLoading: boolean;
} | null>(null);

const CacheProvider: React.FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ children }) => {
  const {
    enabledFeatureData,
    enabledFeatureDataLoading,
  } = usePostFeatureDataSubscription();

  const contextValue = {
    enabledFeatureData,
    enabledFeatureDataLoading,
  };

  return (
    <CommonCacheContext.Provider value={contextValue}>
      {enabledFeatureDataLoading ? <div /> : children}
    </CommonCacheContext.Provider>
  );
};

export default CacheProvider;
